import React from "react";
import LegalDocumentPage from "./LegalDocumentPage";
import { getPrivacy } from "../../api/legal";

export default function Privacy() {
  return (
    <LegalDocumentPage
      fetcher={getPrivacy}
      fallbackTitle="Política de Privacidade"
    />
  );
}
